'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Search = function Search() {
  return React__default["default"].createElement("svg", {
    width: "816",
    height: "411",
    viewBox: "0 0 816 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter0_f)"
  }, React__default["default"].createElement("path", {
    d: "M534.91 260H150.974C148.964 260 148.21 262.631 149.914 263.696L319.511 369.695C319.831 369.894 320.2 369.999 320.576 369.998L697.258 369.018C699.249 369.012 700.011 366.419 698.339 365.338L535.996 260.321C535.672 260.111 535.295 260 534.91 260Z",
    fill: "#263238"
  })), React__default["default"].createElement("rect", {
    y: "244",
    width: "816",
    height: "167",
    fill: "url(#paint0_radial)"
  }), React__default["default"].createElement("rect", {
    opacity: "0.4",
    x: "108",
    y: "244",
    width: "600",
    height: "2",
    rx: "1",
    fill: "#1565C0"
  }), React__default["default"].createElement("path", {
    d: "M379.457 1.11207L527 72.6266L527 79H233L233 72.6246L379.457 1.11207Z",
    fill: "#E3F2FD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M236 207H480L609 268H337L236 207Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M199 220H486L652 302H332L199 220Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M159 236H490L688 338H320L159 236Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M261 71.4942C261 70.7822 261.723 70.2983 262.381 70.5698L340.381 102.745C340.756 102.899 341 103.264 341 103.669V260.234C341 261.011 340.152 261.491 339.486 261.091L261.486 214.291C261.184 214.111 261 213.785 261 213.434V71.4942Z",
    fill: "#1565C0"
  }), React__default["default"].createElement("path", {
    d: "M332 116.344L340 118.744V250.079L332 244.479L332 116.344Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M304 96L320 96V228H304L304 96Z",
    fill: "#3387CD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M294 96.1805L304 97.8471L304 229.259L294 223.426L294 96.1805Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M327 106.22L340 108.82V118.698L327 115.232L327 106.22Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M254 84.2704V78.3706L330 102.73V108.629L254 84.2704Z",
    fill: "#3387CD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M237 230.436V208.772L336 268.564V290.228L237 230.436Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M200 243.442V221.791L331 302.558V324.209L200 243.442Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M339 103C339 102.448 339.448 102 340 102H578C578.552 102 579 102.448 579 103V261C579 261.552 578.552 262 578 262H340C339.448 262 339 261.552 339 261V103Z",
    fill: "#1565C0"
  }), React__default["default"].createElement("path", {
    d: "M332 103H594V109H332V103Z",
    fill: "#3387CD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M338 269H608V291H338V269Z",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M333 303H651V325H333V303Z",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M160 259.45V237.817L319 338.55V360.183L160 259.45Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M321 339H687V361H321V339Z",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M459.457 25.1121L607 96.6266L607 103H313L313 96.6246L459.457 25.1121Z",
    fill: "#E3F2FD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M375.6 84L459.6 42.2221C459.882 42.0823 460.212 42.0826 460.493 42.2232L544 84",
    stroke: "#3387CD",
    "stroke-width": "3",
    "stroke-linecap": "round"
  }), React__default["default"].createElement("path", {
    d: "M375.6 81L459.6 39.2221C459.882 39.0823 460.212 39.0826 460.493 39.2232L544 81",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }), React__default["default"].createElement("path", {
    d: "M262 77.105L270 77.905V208.234L262 203.434L262 77.105Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M258 201.748L273 210.572V220.252L258 211.428L258 201.748Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M234 74.3235L313 96.7556L313 101.677L234 79.2444L234 79.2444V74.3235Z",
    fill: "#3387CD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M380.085 1.0729L458.285 25.2087L312.912 95.9309L234.733 72.7669L380.085 1.0729Z",
    fill: "#BBDEFB",
    stroke: "#1565C0",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("rect", {
    x: "440",
    y: "109",
    width: "46",
    height: "10",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "448",
    y: "119",
    width: "30",
    height: "132",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "440",
    y: "251",
    width: "46",
    height: "10",
    rx: "1",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "548",
    y: "109",
    width: "38",
    height: "10",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "556",
    y: "119",
    width: "22",
    height: "132",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "548",
    y: "251",
    width: "38",
    height: "10",
    rx: "1",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "340",
    y: "109",
    width: "30",
    height: "10",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("mask", {
    id: "path-36-inside-1",
    fill: "white"
  }, React__default["default"].createElement("rect", {
    x: "339",
    y: "118",
    width: "24",
    height: "134",
    rx: "1"
  })), React__default["default"].createElement("rect", {
    x: "339",
    y: "118",
    width: "24",
    height: "134",
    rx: "1",
    fill: "white",
    stroke: "#1565C0",
    "stroke-width": "4",
    mask: "url(#path-36-inside-1)"
  }), React__default["default"].createElement("rect", {
    x: "267",
    y: "92",
    width: "1",
    height: "109",
    rx: "0.5",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "264",
    y: "91",
    width: "1",
    height: "109",
    rx: "0.5",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M340 251L370 251V261H340V251Z",
    fill: "#EDF6FE",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M304 229L326 229V238L304 238L304 229Z",
    fill: "#3387CD",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M327 241.973L340 251.507L340 261.131L327 252.465L327 241.973Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("path", {
    d: "M290 220.766L303 228.566L303 238.234L290 230.434L290 220.766Z",
    fill: "#C2DBF0",
    stroke: "#1565C0",
    "stroke-width": "2"
  }), React__default["default"].createElement("rect", {
    x: "463",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "457",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "449",
    y: "127",
    width: "4",
    height: "122",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "557",
    y: "121",
    width: "4",
    height: "128",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "475",
    y: "120",
    width: "2",
    height: "122",
    rx: "1",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "359",
    y: "120",
    width: "2",
    height: "128",
    rx: "1",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "469",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "563",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "569",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "575",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "344",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "350",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "335",
    y: "123",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "300",
    y: "103",
    width: "1",
    height: "118",
    rx: "0.5",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "308",
    y: "106",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "313",
    y: "106",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "297",
    y: "102",
    width: "1",
    height: "118",
    rx: "0.5",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "356",
    y: "126",
    width: "2",
    height: "118",
    rx: "1",
    fill: "#E3F2FD"
  }), React__default["default"].createElement("rect", {
    x: "347",
    y: "270",
    width: "256",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "339",
    y: "286",
    width: "264",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "345",
    y: "320",
    width: "296",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "329",
    y: "356",
    width: "352",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "335",
    y: "104",
    width: "256",
    height: "2",
    rx: "1",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "551",
    y: "252",
    width: "32",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "551",
    y: "252",
    width: "32",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "551",
    y: "252",
    width: "32",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "444",
    y: "252",
    width: "40",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "444",
    y: "252",
    width: "40",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "444",
    y: "252",
    width: "40",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "343",
    y: "252",
    width: "24",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "343",
    y: "252",
    width: "24",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "343",
    y: "252",
    width: "24",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "443",
    y: "116",
    width: "40",
    height: "2",
    rx: "1",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "343",
    y: "116",
    width: "24",
    height: "2",
    rx: "1",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "551",
    y: "116",
    width: "32",
    height: "2",
    rx: "1",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "339",
    y: "304",
    width: "304",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "327",
    y: "341",
    width: "352",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("path", {
    d: "M241 214L332 269",
    stroke: "#EDF6FE",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("path", {
    d: "M241 230L332 285",
    stroke: "#3387CD",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("path", {
    d: "M203 242L326 318",
    stroke: "#3387CD",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("path", {
    d: "M163 258L310 351",
    stroke: "#3387CD",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("path", {
    d: "M209 230L321 299",
    stroke: "#EDF6FE",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    id: "filter0_f",
    x: "136.97",
    y: "248",
    width: "574.287",
    height: "133.999",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, React__default["default"].createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("radialGradient", {
    id: "paint0_radial",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408 244) rotate(90) scale(146 509.128)"
  }, React__default["default"].createElement("stop", {
    "stop-color": "#2196F3",
    "stop-opacity": "0.08"
  }), React__default["default"].createElement("stop", {
    offset: "1",
    "stop-color": "#C4C4C4",
    "stop-opacity": "0"
  }))));
};

module.exports = Search;
